import React from "react"

export default function PauseIcon() {
  return (
    <svg viewBox="0 0 18 18" width="18" height="18" focusable="false">
      <path fill="#fff" d="M6 1H3c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zm6 0c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1h-3z" />
    </svg>
  )
}
